import CometMarquee from 'comet-marquee';
// import 'comet-marquee/dist/comet-marquee.css';

const testimonialsMarqueeArr = document.querySelectorAll('.testimonials-marquee');
testimonialsMarqueeArr.forEach((testimonialMarqueeEl, i) => {
  const testimonialsMarquee = new CometMarquee(testimonialMarqueeEl, {
    speed: 40,
    pauseOnHover: true,
    initialShift: true,
    pauseOnInvisible: true,
    syncPause: true,
    repeatCount: 3,
    forceAnimation: true,
    forceAnimationWidth: 2,
  });
})